export default __webpack_public_path__ + "static/media/foodfriends-shirt.f591a110.png";